$(function () {

    interface ITabGeneratorParameters {
        separationTrigger: string;
    }

    class TabGenerator {
        private container: JQuery;
        private parameters: ITabGeneratorParameters;

        constructor(container: JQuery) {
            this.container = container;
            this.parameters = this.getParameters(container);
            this.init();
        }

        private init(): void {
            var separators = this.container.find(this.parameters.separationTrigger);
            if (separators.length <= 1) {
                return;
            }

            var tabHeader = $(`<ul class="nav nav-tabs font-size-1 position-relative z-1" role="tablist"></ul>`);
            this.container.prepend(tabHeader);

            var tabContent = $(`<div class="tab-content card p-3"></div>`);
            tabContent.insertAfter(tabHeader);
            tabContent.css('border-top-left-radius', '0');

            separators.each((index, element) => {
                var separator = $(element);
                var targetId = separator.text().toLowerCase().replace(/\W/g, '_');
                separator.data('targetid', targetId);

                var active = window.location.hash == targetId || index == 0;
                this.addToHeader(tabHeader, separator, active);
                this.addToContent(tabContent, separator, active);
            });
        }

        private addToHeader(header: JQuery, target: JQuery, active: boolean): void {
            var text = target.text();
            var targetId = target.data('targetid');
            var labelledId = targetId + '_tab';
            header.append(`
                <li class="nav-item">
					<a class="nav-link border border-bottom-0 ${active ? 'active' : ''}" id="${labelledId}" data-toggle="tab" href="#${targetId}" role="tab" aria-controls="${targetId}" aria-selected="true">${text}</a>
				</li>
            `);
        }

        private addToContent(content: JQuery, target: JQuery, active: boolean): void {
            var text = target.text();
            var targetId = target.data('targetid');
            var labelledId = targetId + '_tab';
            
            var tabElement = $(`
                <div class="tab-pane fade ${active ? 'active show' : ''}" id="${targetId}" role="tabpanel" aria-labelledby="${labelledId}">
                    
				</div>
            `);
            var tabContent = target.nextUntil(this.parameters.separationTrigger).addBack();
            tabContent.appendTo(tabElement);

            content.append(tabElement);
        }

        private getParameters(element: JQuery): ITabGeneratorParameters {
            var parameters = {};
            if (element) {
                parameters = {
                    separationTrigger: element.data('separationtrigger')
                }
            }
            return $.extend({
                separationTrigger: 'h3'
            }, parameters);
        }
    }

    const pluginName = 'bookhus_tabgenerator';
    $('[data-widget="tabgenerator"]').each((index, elem) => {
        var $elem = $(elem);
        if (!$elem.data(pluginName)) {
            $elem.data(pluginName, new TabGenerator($elem))
        }
    });

});